import React from 'react';
import WOW from 'wowjs';
import { useEffect } from 'react';
import { useSelector } from 'react-redux'; // Added useSelector import
import translate from '../translate';

function Support() {
    const language = useSelector((state) => state.view.selectedLanguage); // Defined language variable
    const componentName = 'support'; // Defined componentName variable

    useEffect(() => {
        const wow = new WOW.WOW({
            live: false,
            offset: 100,
            mobile: true,
        });
        wow.init();
    }, []);

    return (
        <div className="support-secttion pt-130 pb-130">
        <div className="container">
            <div className="row mt-none-30">
                <div className="col-lg-4 col-md-6 mt-30">
                    <div className="support-box wow fadeInUp" data-wow-delay="00ms" data-wow-duration="800ms">
                        <div className="icon">
                            <img src="assets/img/icons/support-1.png" alt=""/>
                        </div>
                        <div className="content mt-25">
                            <h4 className="title">{translate(componentName, 'visitUsTitle', language)}</h4> {/* Replaced text */}
                            <p>{translate(componentName, 'visitUsAddress', language)}</p> {/* Replaced text */}
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 mt-30">
                    <div className="support-box wow fadeInUp" data-wow-delay="200ms" data-wow-duration="800ms">
                        <div className="icon">
                            <img src="assets/img/icons/support-2.png" alt=""/>
                        </div>
                        <div className="content mt-25">
                            <h4 className="title">{translate(componentName, 'contactUsTitle', language)}</h4> {/* Replaced text */}
                            <p>
                                <a href="tel:+27832763009">{translate(componentName, 'contactUsPhone', language)}</a> {/* Replaced text */}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 mt-30">
                    <div className="support-box wow fadeInUp" data-wow-delay="400ms" data-wow-duration="800ms">
                        <div className="icon">
                            <img src="assets/img/icons/support-3.png" alt=""/>
                        </div>
                        <div className="content mt-25">
                            <h4 className="title">{translate(componentName, 'emailUsTitle', language)}</h4> {/* Replaced text */}
                            <p>
                                <a href="mailto:info@alpinesoft.ai">{translate(componentName, 'emailUsAddress', language)}</a> {/* Replaced text */}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Support;